import { Button } from '../ui/button';
import { Calendar, ChevronLeft, ChevronRight } from 'lucide-react';

export default function CalendarTab({ highlightedDates, calendarMonth, setCalendarMonth, toggleCalendarDate }) {
  const year = calendarMonth.getFullYear();
  const month = calendarMonth.getMonth();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const daysInMonth = lastDay.getDate();
  let startDay = firstDay.getDay() - 1;
  if (startDay < 0) startDay = 6;

  const cells = [];
  for (let i = 0; i < startDay; i++) {
    cells.push(<div key={`empty-${i}`} className="aspect-square" />);
  }
  for (let day = 1; day <= daysInMonth; day++) {
    const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const isHighlighted = highlightedDates.includes(dateStr);
    const isToday = new Date().toISOString().split('T')[0] === dateStr;
    cells.push(
      <button
        key={day}
        onClick={() => toggleCalendarDate(dateStr)}
        className={`aspect-square flex items-center justify-center text-sm font-medium rounded-xl transition-all duration-200
          ${isHighlighted ? 'bg-[#007aff] text-white shadow-md' : 'bg-[#f5f5f7] hover:bg-[#e8e8ed] text-[#1d1d1f]'}
          ${isToday && !isHighlighted ? 'ring-2 ring-[#007aff]' : ''}`}
      >
        {day}
      </button>
    );
  }

  return (
    <div className="sidebar-scroll p-4">
      <div className="flex items-center justify-between mb-4">
        <Button variant="ghost" size="sm" className="rounded-xl" onClick={() => setCalendarMonth(new Date(year, month - 1))}>
          <ChevronLeft className="w-5 h-5" />
        </Button>
        <h3 className="font-semibold text-lg text-[#1d1d1f]">
          {calendarMonth.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}
        </h3>
        <Button variant="ghost" size="sm" className="rounded-xl" onClick={() => setCalendarMonth(new Date(year, month + 1))}>
          <ChevronRight className="w-5 h-5" />
        </Button>
      </div>
      <div className="grid grid-cols-7 gap-1 mb-2">
        {['M', 'T', 'W', 'T', 'F', 'S', 'S'].map((d, i) => (
          <div key={i} className="text-center text-xs font-semibold text-[#86868b] py-1">{d}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1">{cells}</div>
      <div className="mt-4 pt-4 border-t border-[rgba(0,0,0,0.08)]">
        <div className="flex items-center gap-4 text-xs text-[#86868b]">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-lg bg-[#007aff]" />
            <span>Highlighted ({highlightedDates.length})</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-lg ring-2 ring-[#007aff] bg-[#f5f5f7]" />
            <span>Today</span>
          </div>
        </div>
      </div>
    </div>
  );
}
